jQuery(function () {
    var form = $('.js-email-settings-form');
    if (!form) {
        return;
    }
    $(form).on('change', function (e) {
        e.preventDefault();
        submitForm();
    });
    function submitForm() {
        var url = form.attr('action');
        $.ajax({
            type: 'POST',
            url: url,
            data: form.serialize(),
            success: function (data) {
                //TODO: handle success + failure?
            }
        });
    }
});
